const benefits = [
  {
    icon: 'ri-mental-health-line',
    title: '深度放松',
    description: '通过精心设计的音频频率与节奏，引导大脑进入 Alpha 波状态，帮助你从紧张中彻底解放出来，感受全身心的放松。',
    image: 'https://readdy.ai/api/search-image?query=Person%20meditating%20peacefully%20in%20minimalist%20room%20with%20soft%20warm%20light%2C%20cream%20walls%2C%20indoor%20plant%2C%20calm%20serene%20atmosphere%2C%20wellness%20lifestyle%20photography%2C%20gentle%20beige%20tones&width=800&height=600&seq=benefit-relax-01&orientation=landscape',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '改善睡眠',
    description: '白噪音与自然音效能有效屏蔽环境干扰，配合渐进式放松引导，帮助你更快入睡、更深睡眠，告别辗转反侧的夜晚。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20with%20soft%20moonlight%20through%20window%2C%20fluffy%20white%20bedding%2C%20minimalist%20interior%2C%20peaceful%20night%20atmosphere%2C%20cream%20and%20soft%20gray%20tones%2C%20calming%20sleep%20environment&width=800&height=600&seq=benefit-sleep-01&orientation=landscape',
  },
  {
    icon: 'ri-heart-line',
    title: '缓解焦虑',
    description: '温柔耳语与角色扮演触发大脑释放催产素，产生安全感和亲密感。研究表明定期聆听可显著降低日常焦虑水平。',
    image: 'https://readdy.ai/api/search-image?query=Calm%20person%20sitting%20by%20window%20with%20warm%20sunlight%2C%20holding%20warm%20tea%2C%20peaceful%20expression%2C%20minimalist%20cozy%20interior%2C%20cream%20and%20soft%20golden%20tones%2C%20serene%20atmosphere&width=800&height=600&seq=benefit-anxiety-01&orientation=landscape',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            声音的力量
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            ASMR 不仅是听觉享受，更是一种科学验证的身心疗愈方式
          </p>
        </div>

        <div className="flex flex-col gap-12 md:gap-20">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } items-center gap-8 md:gap-12`}
            >
              <div className="w-full lg:w-1/2">
                <div className="aspect-[4/3] rounded-lg overflow-hidden">
                  <img
                    src={benefit.image}
                    alt={benefit.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
                  <i className={`${benefit.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  {benefit.title}
                </h3>
                <p className="text-base text-foreground-600 leading-relaxed max-w-lg">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}